import moment from "moment";
import { DRIVER_TYPE_NAMES, ODF_DRIVER_TYPE } from "../consts/driverTypes";

const allFields = [
  {
    headerName: "Depot",
    key: "depotCode",
  },
  {
    headerName: "Driver Code",
    key: "driverCode",
    transform: (value) => value || "",
  },
  {
    headerName: "Driver Type",
    key: "driverType",
    transform: (value) => value || "",
  },
  {
    headerName: "Driver Category",
    key: "driverType",
    transform: (value) => DRIVER_TYPE_NAMES?.[value] || "",
  },
  {
    headerName: "Driver Name",
    key: "driverName",
    transform: (value) => value || "",
  },
  {
    headerName: "Vehicle Type",
    key: "vehicleType",
    transform: (value) => value || "",
  },
  {
    headerName: "Monday",
    key: "day",
    day: 1,
  },
  {
    headerName: "Tuesday",
    key: "day",
    day: 2,
  },
  {
    headerName: "Wednesday",
    key: "day",
    day: 3,
  },
  {
    headerName: "Thursday",
    key: "day",
    day: 4,
  },
  {
    headerName: "Friday",
    key: "day",
    day: 5,
  },
  {
    headerName: "Saturday",
    key: "day",
    day: 6,
  },
  {
    headerName: "Sunday",
    key: "day",
    day: 0,
  },
];

const toCellString = (value, transform) => {
  if (transform) return transform(value);
  else return `${value || ""}`;
};

const toRowString = (fields, driver, depotCode, matrixDays) =>
  fields
    .map(({ key, transform, day = "" }) => {
      if (key === "day") return getDayRoutePlanned(driver, day, matrixDays);
      return toCellString(
        key === "depotCode" ? depotCode : driver[key],
        transform
      );
    })
    .join(",");

const getDayRoutePlanned = (driver, day, matrixDays) => {
  const { driverCode, driverType } = driver;
  const { drivers: matrixDayDrivers } = matrixDays?.[day] || {};

  const { routeCode: driverRouteCode, plannedDriverCode } =
    matrixDayDrivers?.[driverCode];

  // If driver is ODF and has a planned driver, use the planned driver's route code
  if (driverType === ODF_DRIVER_TYPE && plannedDriverCode) {
    const { routeCode: plannedDriverRouteCode } =
      matrixDayDrivers?.[plannedDriverCode];
    return plannedDriverRouteCode || "";
  } else {
    return driverRouteCode || "";
  }
};

export const getDriversExtract = (drivers, depotCode, matrixDays) => {
  if (!drivers?.length) return {};
  const headerRow = allFields.map(({ headerName }) => headerName).join(",");
  const csv = drivers
    .reduce(
      (acc, driver) => {
        acc.push(toRowString(allFields, driver, depotCode, matrixDays));
        return acc;
      },
      [headerRow]
    )
    .join("\r\n");

  return {
    url: URL.createObjectURL(new Blob([csv])),
    fileName: `${moment().tz("Europe/London").format("YYYY-MM-DD HH-mm")}.csv`,
  };
};
